import React from 'react';
import { Section } from './ui/Section';
export function Guarantee() {
  const guaranteeItems = [{
    icon: '✅',
    title: 'Reembolso 100% garantizado',
    desc: 'Te devolvemos hasta el último céntimo de tu inversión'
  }, {
    icon: '✅',
    title: 'Sin preguntas incómodas',
    desc: 'Solo escríbenos un correo y procesamos tu reembolso'
  }, {
    icon: '✅',
    title: 'El riesgo es nuestro, no tuyo',
    desc: 'Pruébalo sin presión durante una semana completa'
  }];
  return <Section variant="alt" data-id="element-122">
      <div className="bg-white border-2 border-brand-borderAccent rounded-3xl p-6 md:p-8 text-center max-w-3xl mx-auto shadow-card" data-id="element-123">
        <div className="text-5xl mb-4" data-id="element-124">🛡️</div>
        <h2 className="font-display text-3xl md:text-4xl font-bold mb-4 text-brand-title" data-id="element-125">
          Garantía de Hierro — 7 Días
        </h2>
        <p className="font-body text-xl text-brand-subtitle font-semibold leading-relaxed mb-6" data-id="element-126">
          Pruébalo 7 días. Si no te encanta, te devolvemos cada euro.
        </p>
        <p className="font-body text-brand-text leading-relaxed mb-6" data-id="element-127">
          Estamos tan seguros de que el Manual del Instructor de Sevillanas PRO
          transformará la forma en que enseñas que asumimos todo el riesgo por
          ti.
        </p>

        <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-128">
          ← Scroll to see full table →
        </div>

        <div className="overflow-x-auto mb-6" data-id="element-129">
          <table className="w-full min-w-[400px] border-collapse bg-brand-bgAlt rounded-xl overflow-hidden border border-brand-border" data-id="element-130">
            <thead data-id="element-131">
              <tr className="border-b border-brand-border" data-id="element-132">
                <th className="text-left p-3 font-heading font-bold text-brand-subtitle text-sm tracking-wide uppercase" data-id="element-133">
                  Garantía
                </th>
                <th className="text-left p-3 font-heading font-bold text-brand-subtitle text-sm tracking-wide uppercase" data-id="element-134">
                  Detalle
                </th>
              </tr>
            </thead>
            <tbody data-id="element-135">
              {guaranteeItems.map((item, i) => <tr key={i} className="border-b border-brand-border last:border-0 bg-white" data-id="element-136">
                  <td className="p-3 text-2xl" data-id="element-137">{item.icon}</td>
                  <td className="p-3" data-id="element-138">
                    <div className="font-heading font-bold text-brand-subtitle mb-1 text-sm" data-id="element-139">
                      {item.title}
                    </div>
                    <div className="font-body text-brand-text text-sm" data-id="element-140">
                      {item.desc}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="font-body text-brand-title font-semibold text-lg italic" data-id="element-141">
          "Si no te ahorra tiempo y no mejora tus clases, no nos lo merecemos."
        </p>
      </div>
    </Section>;
}